var React = require('react');

function InfoCircle (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"\n    Information\n  "),React.createElement("path",{"d":"M10 0a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm1 15H9V9h2v6zm0-8H9V5h2v2z","key":1})]);
}

InfoCircle.defaultProps = {"viewBox":"0 0 20 20"};

module.exports = InfoCircle;

InfoCircle.default = InfoCircle;
